/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';

import {
  Input, Select, Radio, Form, Row, Col,
} from 'antd';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    span: 12,
  },
  wrapperCol: {
    span: 12,
  },
};
const TransactionChargeForm = ({
  form,
  currencies,
  paymentMethods,
  selectedPaymentMethod,
  selectedCurrency,
  processors,
  providers,
  transactionTypes,
  processingTypes,
  selectedProcessingTypes,
  selectedTransactionType,
  selectedProvider,
  selectedProcessor,
  selectedTrafficTypes,
  minimumAmount,
  maximumAmount,
  handleChange,
}) => {
  const currencyOptions = currencies.length
  && currencies.map((currency) => (
    <Option key={currency._id} value={currency._id}>
      {currency.name}
    </Option>
  ));
  const paymentMethodOptions = paymentMethods.length
  && paymentMethods.map((paymentMethod) => (
    <Option key={paymentMethod._id} value={paymentMethod._id}>
      {paymentMethod.code}
    </Option>
  ));
  const transactionTypesOptions = transactionTypes.length
  && transactionTypes.map((transactionType) => (
    <Option key={transactionType._id} value={transactionType._id}>
      {transactionType.name}
    </Option>
  ));
  const providersOptions = providers.length
  && providers.map((provider) => (
    <Option key={provider._id} value={provider._id}>
      {provider.name}
    </Option>
  ));
  const processorsOptions = processors.length
  && processors.map((processor) => (
    <Option key={processor._id} value={processor._id}>
      {processor.name}
    </Option>
  ));

  const processingTypesOptions = processingTypes.length
  && processingTypes.map((processingType) => (
    <Option key={processingType._id} value={processingType._id}>
      {processingType.name}
    </Option>
  ));

  const trafficTypeOptions = selectedProcessor?.traffic_types && selectedProcessor.traffic_types
    .map((trafficType) => (
      <Option className="gx-text-capitalize" key={trafficType}>{trafficType}</Option>
    ));

  return (
    <Form
      name="basic"
      className="gx-form-row0"
      ref={form}
      {...formItemLayout}
      initialValues={{
        deny_ftds: false,
        is_active: false,
        use_s2s_for_hpp: true,
      }}
    >
      <Row>
        <Col xl={15} lg={15} md={12} sm={24} xs={12}>

          <Form.Item
            label="Payment Method"
          >
            <Select
              allowClear
              showArrow
              style={{ width: '100%' }}
              placeholder="Please select payment Method"
              value={selectedPaymentMethod?.name}
              onChange={(e) => handleChange(e, 'payment_method')}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0}
            >
              {paymentMethodOptions}
            </Select>
          </Form.Item>

          <Form.Item
            label="Currency"
          >
            <Select
              allowClear
              showArrow
              style={{ width: '100%' }}
              placeholder="Please select currency"
              value={selectedCurrency?.name}
              onChange={(e) => handleChange(e, 'currency')}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0}
            >
              {currencyOptions}
            </Select>
          </Form.Item>

          <Form.Item
            label="Transaction Types"
          >
            <Select
              allowClear
              showArrow
              style={{ width: '100%' }}
              placeholder="Please select transaction type"
              value={selectedTransactionType?.name}
              onChange={(e) => handleChange(e, 'transaction_type')}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0}
            >
              {transactionTypesOptions}
            </Select>
          </Form.Item>
          <Form.Item
            label="Processor"
          >
            <Select
              allowClear
              showArrow
              style={{ width: '100%' }}
              placeholder="Please select processor"
              value={selectedProcessor?.name}
              onChange={(e) => handleChange(e, 'processor')}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0}
            >
              {processorsOptions}
            </Select>
          </Form.Item>
          <Form.Item label="Traffic Type Allowed">
            <Select
              allowClear
              mode="multiple"
              name="traffic_types"
              value={selectedTrafficTypes}
              onChange={(e) => handleChange(e, 'traffic_types')}
            >
              {trafficTypeOptions}
            </Select>
          </Form.Item>
          <Form.Item
            label="Provider"
          >
            <Select
              allowClear
              showArrow
              style={{ width: '100%' }}
              placeholder="Please select provider"
              value={selectedProvider?.name}
              onChange={(e) => handleChange(e, 'provider')}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0}
            >
              {providersOptions}
            </Select>
          </Form.Item>
          <Form.Item
            label="Deny FTDS"
            name="deny_ftds"
          >
            <Radio.Group>
              <Radio value>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xl={9} lg={9} md={12} sm={24} xs={12}>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="PSP Charge (Fixed)"
            name="processor_fixed_charge"
          >
            <Input placeholder="PSP Charge (Fixed)" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="PSP Charge (%)"
            name="processor_percentage_charge"
          >
            <Input placeholder="PSP Charge (%)" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Our Charge (fixed)"
            name="p2p_fixed_charge"
          >
            <Input placeholder="Our Charge (fixed)" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Our Charge (%)"
            name="p2p_percentage_charge"
          >
            <Input placeholder="Our Charge (%)" />
          </Form.Item>
          <Form.Item label="Minimum Amount">
            <Select
              name="minimum_amount"
              value={minimumAmount}
              onChange={(e) => handleChange(e, 'minimum_amount')}
            >
              <Option key={0}>0</Option>
              <Option key={1}>1</Option>
              <Option key={5}>5</Option>
              <Option key={10}>10</Option>
              <Option key={20}>20</Option>
              <Option key={50}>50</Option>
              <Option key={100}>100</Option>
              <Option key={200}>200</Option>
              <Option key={300}>300</Option>
              <Option key={400}>400</Option>
              <Option key={500}>500</Option>
              <Option key={1000}>1000</Option>
              <Option key={2000}>2000</Option>
              <Option key={3000}>3000</Option>
              <Option key={5000}>5000</Option>
              <Option key={10000}>10000</Option>
              <Option key={15000}>15000</Option>
              <Option key={20000}>20000</Option>
              <Option key={60000}>60000</Option>
              <Option key={500000}>500000</Option>
              <Option key={1000000}>1000000</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Maximum Amount">
            <Select
              name="maximum_amount"
              value={maximumAmount}
              onChange={(e) => handleChange(e, 'maximum_amount')}
            >
              <Option key={0}>0</Option>
              <Option key={50}>50</Option>
              <Option key={100}>100</Option>
              <Option key={500}>500</Option>
              <Option key={1000}>1000</Option>
              <Option key={2000}>2000</Option>
              <Option key={3000}>3000</Option>
              <Option key={5000}>5000</Option>
              <Option key={10000}>10000</Option>
              <Option key={15000}>15000</Option>
              <Option key={20000}>20000</Option>
              <Option key={60000}>60000</Option>
              <Option key={500000}>500000</Option>
              <Option key={1000000}>1000000</Option>
              <Option key={2000000}>2000000</Option>
              <Option key={3000000}>3000000</Option>
              <Option key={3500000}>3500000</Option>
              <Option key={4000000}>4000000</Option>
              <Option key={4500000}>4500000</Option>
              <Option key={5000000}>5000000</Option>
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Mid Daily Limit Amount"
            name="daily_limit_amount"
            initialValue={0}
          >
            <Input max={8} placeholder="Daily Limit Amount" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Decimal Places"
            name="decimal_places"
          >
            <Input placeholder="Decimal Places" />
          </Form.Item>
          <Form.Item
            rules={[{
              required: true,
              message: 'A number value must be entered',
              pattern: new RegExp(/^[0-9]+$/),
            }]}
            label="Processing Rank"
            name="rank"
            initialValue="1"
          >
            <Input placeholder="Processing Rank" defaultValue={1} />
          </Form.Item>
          <Form.Item
            label="Use S2S for HPP"
            name="use_s2s_for_hpp"
            title="If checked, the Hosted page will be rendered on our side to capture card details and process them using S2S. Otherwise, we will request the gateway for the Hosted page link. Ensure S2S is possible with the selected processor before checking this."
          >
            <Radio.Group>
              <Radio value>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Active"
            name="is_active"
          >
            <Radio.Group>
              <Radio value>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

TransactionChargeForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  paymentMethods: PropTypes.arrayOf(PropTypes.shape({})),
  currencies: PropTypes.arrayOf(PropTypes.shape({})),
  processors: PropTypes.arrayOf(PropTypes.shape({})),
  providers: PropTypes.arrayOf(PropTypes.shape({})),
  transactionTypes: PropTypes.arrayOf(PropTypes.shape({})),
  processingTypes: PropTypes.arrayOf(PropTypes.shape({})),
  merchantTypes: PropTypes.arrayOf(PropTypes.shape({})),
  selectedPaymentMethod: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
  selectedCurrency: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
  selectedTransactionType: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
  selectedProvider: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
  selectedProcessor: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
  selectedProcessingTypes: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
  selectedTrafficTypes: PropTypes.arrayOf(PropTypes.string),
  handleChange: PropTypes.func.isRequired,
  minimumAmount: PropTypes.number,
  maximumAmount: PropTypes.number,
};

TransactionChargeForm.defaultProps = {
  form: {},
  currencies: [],
  paymentMethods: [],
  processors: [],
  providers: [],
  transactionTypes: [],
  processingTypes: [],
  merchantTypes: [],
  selectedPaymentMethod: null,
  selectedCurrency: null,
  selectedTransactionType: null,
  selectedProvider: null,
  selectedProcessor: null,
  selectedProcessingTypes: null,
  selectedTrafficTypes: [],
  minimumAmount: 0,
  maximumAmount: 0,
};

export default TransactionChargeForm;
